import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page-heading" }
const _hoisted_3 = { class: "task-create-layout" }
const _hoisted_4 = { class: "task-title-field" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "task-deadline-field" }
const _hoisted_8 = {
  key: 1,
  class: "kanban"
}
const _hoisted_9 = ["onDragenter", "onDrop"]
const _hoisted_10 = ["onDragstart", "onClick"]
const _hoisted_11 = ["onSubmit"]
const _hoisted_12 = ["onKeydown"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 2,
  class: "task-list-view"
}
const _hoisted_16 = { class: "task-list-filters panel" }
const _hoisted_17 = { class: "partner-filter" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "notice error"
}
const _hoisted_22 = { class: "panel task-list-table" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "loading"
}
const _hoisted_25 = {
  key: 1,
  class: "loading"
}
const _hoisted_26 = { class: "pagination" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 3,
  class: "month-calendar"
}
const _hoisted_30 = { class: "calendar-toolbar" }
const _hoisted_31 = { class: "weekday-row" }
const _hoisted_32 = { class: "calendar-grid" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "jira-modal task-card-modal" }
const _hoisted_35 = { class: "jira-modal-header" }
const _hoisted_36 = { class: "jira-modal-layout" }
const _hoisted_37 = { class: "jira-main" }
const _hoisted_38 = { class: "entity-tabs" }
const _hoisted_39 = { class: "jira-section" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "jira-section" }
const _hoisted_42 = {
  key: 1,
  class: "jira-section activity-section"
}
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "activity-feed" }
const _hoisted_45 = { class: "activity-avatar" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "jira-sidebar" }
const _hoisted_48 = { class: "field-block" }
const _hoisted_49 = { class: "editable-field-row" }
const _hoisted_50 = { class: "editable-field-row" }
const _hoisted_51 = { class: "editable-field-row" }
const _hoisted_52 = { class: "editable-field-row" }
const _hoisted_53 = { class: "task-detail-deadline" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "field-readonly" }
const _hoisted_56 = { class: "field-block task-archive-block" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = {
  class: "task-dates-block",
  "aria-label": "Даты задачи"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[36] || (_cache[36] = _createElementVNode("div", null, [
        _createElementVNode("small", null, "Работа"),
        _createElementVNode("h1", null, "Задачи")
      ], -1 /* CACHED */)),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => ($setup.setView('board'))),
          class: _normalizeClass({ primary: $setup.view==='board' })
        }, "Доска", 2 /* CLASS */),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = $event => ($setup.setView('list'))),
          class: _normalizeClass({ primary: $setup.view==='list' })
        }, "Список", 2 /* CLASS */),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = $event => ($setup.setView('calendar'))),
          class: _normalizeClass({ primary: $setup.view==='calendar' })
        }, "Календарь", 2 /* CLASS */),
        _createElementVNode("button", {
          class: "primary",
          onClick: $setup.openCreate
        }, "+ Задача")
      ])
    ]),
    ($setup.showCreate)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "task-create-backdrop",
          onClick: _withModifiers($setup.closeCreate, ["self"])
        }, [
          _createElementVNode("form", {
            class: "task-create-dialog",
            onSubmit: _withModifiers($setup.createTask, ["prevent"])
          }, [
            _createElementVNode("header", null, [
              _cache[37] || (_cache[37] = _createElementVNode("div", null, [
                _createElementVNode("small", null, "Новая задача"),
                _createElementVNode("h2", null, "Создать задачу")
              ], -1 /* CACHED */)),
              _createElementVNode("button", {
                type: "button",
                "aria-label": "Закрыть",
                onClick: $setup.closeCreate
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("main", null, [
                _createElementVNode("label", _hoisted_4, [
                  _cache[38] || (_cache[38] = _createTextVNode("Название", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.form.title) = $event)),
                    placeholder: "Что нужно сделать?",
                    required: "",
                    autofocus: ""
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.form.title]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[39] || (_cache[39] = _createTextVNode("Описание ", -1 /* CACHED */)),
                  _cache[40] || (_cache[40] = _createElementVNode("span", null, "необязательно", -1 /* CACHED */)),
                  _createVNode($setup["RichTextEditor"], {
                    modelValue: $setup.form.description,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.form.description) = $event)),
                    placeholder: "Добавьте детали, ссылки или файлы…"
                  }, null, 8 /* PROPS */, ["modelValue"])
                ])
              ]),
              _createElementVNode("aside", null, [
                _createElementVNode("label", null, [
                  _cache[41] || (_cache[41] = _createTextVNode("Ответственный", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.form.assignee_id) = $event)),
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.users, (user) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: user.id,
                        value: user.id
                      }, _toDisplayString(user.name), 9 /* TEXT, PROPS */, _hoisted_5))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $setup.form.assignee_id]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[42] || (_cache[42] = _createTextVNode("Партнёр", -1 /* CACHED */)),
                  _createVNode($setup["PartnerPicker"], {
                    modelValue: $setup.form.partner_id,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.form.partner_id) = $event))
                  }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _createElementVNode("label", null, [
                  _cache[43] || (_cache[43] = _createTextVNode("Стадия", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.form.stage_id) = $event)),
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: stage.id,
                        value: stage.id
                      }, _toDisplayString(stage.name), 9 /* TEXT, PROPS */, _hoisted_6))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $setup.form.stage_id]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[45] || (_cache[45] = _createTextVNode("Приоритет", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.form.priority) = $event))
                  }, [...(_cache[44] || (_cache[44] = [
                    _createStaticVNode("<option value=\"lowest\">Самый низкий</option><option value=\"low\">Низкий</option><option value=\"medium\">Средний</option><option value=\"high\">Высокий</option><option value=\"highest\">Критический</option>", 5)
                  ]))], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $setup.form.priority]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[46] || (_cache[46] = _createElementVNode("span", null, "Дедлайн", -1 /* CACHED */)),
                  _createVNode($setup["DeadlinePicker"], {
                    modelValue: $setup.form.deadline_at,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.form.deadline_at) = $event))
                  }, null, 8 /* PROPS */, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("footer", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: $setup.closeCreate
              }, "Отмена"),
              _cache[47] || (_cache[47] = _createElementVNode("button", { class: "primary" }, "Создать задачу", -1 /* CACHED */))
            ])
          ], 32 /* NEED_HYDRATION */)
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.view==='board')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage) => {
            return (_openBlock(), _createElementBlock("section", {
              key: stage.id,
              class: _normalizeClass(["kanban-column", { 'drag-target': $setup.dragTargetStageId === stage.id }]),
              onDragenter: _withModifiers($event => ($setup.dragTargetStageId=stage.id), ["prevent"]),
              onDragover: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"])),
              onDragleave: _cache[14] || (_cache[14] = _withModifiers($event => ($setup.dragTargetStageId=null), ["self"])),
              onDrop: _withModifiers($event => ($setup.dropOnStage($event, stage)), ["prevent"])
            }, [
              _createElementVNode("header", null, [
                _createElementVNode("span", {
                  class: "stage-dot",
                  style: _normalizeStyle({ background: stage.color })
                }, null, 4 /* STYLE */),
                _createElementVNode("strong", null, _toDisplayString(stage.name), 1 /* TEXT */),
                _createElementVNode("small", null, _toDisplayString($setup.byStage[stage.id]?.length), 1 /* TEXT */)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.byStage[stage.id], (task) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: task.id,
                  class: _normalizeClass(["task-card", { dragging: $setup.draggingTaskId === task.id }]),
                  draggable: "true",
                  onDragstart: $event => ($setup.startDrag($event, task)),
                  onDragend: $setup.finishDrag,
                  onClick: $event => ($setup.openTask(task))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["priority", `priority-${task.priority}`])
                  }, _toDisplayString(task.priority), 3 /* TEXT, CLASS */),
                  _createElementVNode("h3", null, _toDisplayString(task.title), 1 /* TEXT */),
                  _createElementVNode("p", null, _toDisplayString(task.partner?.name || "Без партнёра"), 1 /* TEXT */),
                  _createElementVNode("footer", null, [
                    _createElementVNode("span", null, _toDisplayString(task.assignee.name), 1 /* TEXT */),
                    _createElementVNode("span", {
                      class: _normalizeClass(["task-deadline", `deadline-${$setup.deadlineState(task)}`])
                    }, [
                      _createVNode($setup["DualTime"], {
                        value: task.deadline_at,
                        empty: "Без дедлайна"
                      }, null, 8 /* PROPS */, ["value"])
                    ], 2 /* CLASS */)
                  ])
                ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_10))
              }), 128 /* KEYED_FRAGMENT */)),
              ($setup.quickCreateStageId===stage.id)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    class: "kanban-quick-create",
                    onSubmit: _withModifiers($event => ($setup.createQuickTask(stage)), ["prevent"])
                  }, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.quickTaskTitle) = $event)),
                      rows: "2",
                      placeholder: "Что нужно сделать?",
                      required: "",
                      autofocus: "",
                      onKeydown: [
                        _cache[11] || (_cache[11] = _withKeys($event => ($setup.quickCreateStageId=null), ["esc"])),
                        _withKeys(_withModifiers($event => ($setup.createQuickTask(stage)), ["exact","prevent"]), ["enter"])
                      ]
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_12), [
                      [_vModelText, $setup.quickTaskTitle]
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "primary",
                        disabled: $setup.quickCreating
                      }, _toDisplayString($setup.quickCreating ? "…" : "Добавить"), 9 /* TEXT, PROPS */, _hoisted_13),
                      _createElementVNode("button", {
                        type: "button",
                        "aria-label": "Отмена",
                        onClick: _cache[12] || (_cache[12] = $event => ($setup.quickCreateStageId=null))
                      }, "×")
                    ])
                  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_11))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "kanban-add-card",
                    onClick: $event => ($setup.startQuickCreate(stage))
                  }, "＋ Создать задачу", 8 /* PROPS */, _hoisted_14))
            ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_9))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : ($setup.view==='list')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, [
                _cache[48] || (_cache[48] = _createElementVNode("span", null, "Партнёр", -1 /* CACHED */)),
                _createVNode($setup["PartnerPicker"], {
                  modelValue: $setup.listPartnerId,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (($setup.listPartnerId) = $event)),
                  onChange: $setup.applyListFilters
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _createElementVNode("label", null, [
                _cache[50] || (_cache[50] = _createElementVNode("span", null, "Ответственный", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($setup.listAssigneeId) = $event)),
                  onChange: $setup.applyListFilters
                }, [
                  _cache[49] || (_cache[49] = _createElementVNode("option", { value: "" }, "Все", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.users, (user) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: user.id,
                      value: user.id
                    }, _toDisplayString(user.name), 9 /* TEXT, PROPS */, _hoisted_18))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelSelect, $setup.listAssigneeId]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[52] || (_cache[52] = _createElementVNode("span", null, "Статус задачи", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => (($setup.listStageId) = $event)),
                  onChange: $setup.applyListFilters
                }, [
                  _cache[51] || (_cache[51] = _createElementVNode("option", { value: "" }, "Все", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: stage.id,
                      value: stage.id
                    }, _toDisplayString(stage.name), 9 /* TEXT, PROPS */, _hoisted_19))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelSelect, $setup.listStageId]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[53] || (_cache[53] = _createElementVNode("span", null, "Дедлайн с", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => (($setup.listDeadlineFrom) = $event)),
                  type: "date",
                  onChange: $setup.applyListFilters
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelText, $setup.listDeadlineFrom]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[54] || (_cache[54] = _createElementVNode("span", null, "Дедлайн по", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (($setup.listDeadlineTo) = $event)),
                  type: "date",
                  onChange: $setup.applyListFilters
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelText, $setup.listDeadlineTo]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[56] || (_cache[56] = _createElementVNode("span", null, "Архив", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (($setup.listArchived) = $event)),
                  onChange: $setup.applyListFilters
                }, [...(_cache[55] || (_cache[55] = [
                  _createElementVNode("option", { value: "active" }, "Активные", -1 /* CACHED */),
                  _createElementVNode("option", { value: "archived" }, "Архивированные", -1 /* CACHED */),
                  _createElementVNode("option", { value: "all" }, "Все", -1 /* CACHED */)
                ]))], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelSelect, $setup.listArchived]
                ])
              ]),
              _createElementVNode("button", { onClick: $setup.resetListFilters }, "Сбросить"),
              _createElementVNode("button", {
                class: "export-link",
                disabled: $setup.listExporting,
                onClick: $setup.downloadTaskExport
              }, _toDisplayString($setup.listExporting ? "Экспорт…" : "Экспорт CSV"), 9 /* TEXT, PROPS */, _hoisted_20)
            ]),
            ($setup.listExportError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString($setup.listExportError), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("table", null, [
                _cache[57] || (_cache[57] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Задача"),
                    _createElementVNode("th", null, "Партнёр"),
                    _createElementVNode("th", null, "Стадия"),
                    _createElementVNode("th", null, "Ответственный"),
                    _createElementVNode("th", null, "Дедлайн"),
                    _createElementVNode("th", null, "Архив")
                  ])
                ], -1 /* CACHED */)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listTasks, (task) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: task.id,
                      class: "clickable",
                      onClick: $event => ($setup.openTask(task))
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("strong", null, _toDisplayString(task.title), 1 /* TEXT */)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(task.partner?.name || '—'), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(task.stage.name), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(task.assignee.name), 1 /* TEXT */),
                      _createElementVNode("td", null, [
                        _createVNode($setup["DualTime"], {
                          value: task.deadline_at
                        }, null, 8 /* PROPS */, ["value"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(task.archived_at ? 'Архивирована' : '—'), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_23))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              ($setup.listLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Загрузка…"))
                : (!$setup.listTasks.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Задачи не найдены"))
                  : _createCommentVNode("v-if", true),
              _createElementVNode("footer", _hoisted_26, [
                _createElementVNode("span", null, _toDisplayString($setup.listTotal ? `${($setup.listPage-1)*$setup.listPerPage+1}–${Math.min($setup.listPage*$setup.listPerPage,$setup.listTotal)} из ${$setup.listTotal}` : 'Нет задач'), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    disabled: $setup.listPage===1,
                    onClick: _cache[21] || (_cache[21] = $event => ($setup.changeListPage($setup.listPage-1)))
                  }, "←", 8 /* PROPS */, _hoisted_27),
                  _createElementVNode("strong", null, _toDisplayString($setup.listPage) + " / " + _toDisplayString($setup.listTotalPages), 1 /* TEXT */),
                  _createElementVNode("button", {
                    disabled: $setup.listPage===$setup.listTotalPages,
                    onClick: _cache[22] || (_cache[22] = $event => ($setup.changeListPage($setup.listPage+1)))
                  }, "→", 8 /* PROPS */, _hoisted_28)
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                onClick: _cache[23] || (_cache[23] = $event => ($setup.changeMonth(-1)))
              }, "‹"),
              _createElementVNode("strong", null, _toDisplayString($setup.monthLabel), 1 /* TEXT */),
              _createElementVNode("button", {
                onClick: _cache[24] || (_cache[24] = $event => ($setup.changeMonth(1)))
              }, "›")
            ]),
            _createElementVNode("div", _hoisted_31, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Пн','Вт','Ср','Чт','Пт','Сб','Вс'], (day) => {
                return _createElementVNode("span", { key: day }, _toDisplayString(day), 1 /* TEXT */)
              }), 64 /* STABLE_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.calendarCells, (cell) => {
                return (_openBlock(), _createElementBlock("section", {
                  key: cell.key,
                  class: _normalizeClass({ empty: cell.empty, today: cell.key === $setup.localDateKey(new Date()) })
                }, [
                  (!cell.empty)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("header", null, _toDisplayString(cell.day), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell.tasks, (task) => {
                          return (_openBlock(), _createElementBlock("article", {
                            key: task.id,
                            onClick: $event => ($setup.openTask(task))
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(task.title), 1 /* TEXT */),
                            _createElementVNode("span", null, [
                              _createVNode($setup["DualTime"], {
                                value: task.deadline_at
                              }, null, 8 /* PROPS */, ["value"]),
                              _createTextVNode(" · " + _toDisplayString(task.assignee.name), 1 /* TEXT */)
                            ])
                          ], 8 /* PROPS */, _hoisted_33))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])),
    ($setup.selected)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "jira-modal-backdrop",
          onClick: _withModifiers($setup.closeTask, ["self"])
        }, [
          _createElementVNode("article", _hoisted_34, [
            _createElementVNode("header", _hoisted_35, [
              _createElementVNode("span", null, "CRM / Tasks / " + _toDisplayString($setup.selected.id), 1 /* TEXT */),
              _createElementVNode("button", {
                class: "close",
                onClick: $setup.closeTask
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("main", _hoisted_37, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => (($setup.taskEdit.title) = $event)),
                  class: "jira-title-input",
                  "aria-label": "Название задачи"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.taskEdit.title]
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("button", {
                    class: _normalizeClass({active:$setup.detailTab==='details'}),
                    onClick: _cache[26] || (_cache[26] = $event => ($setup.detailTab='details'))
                  }, "Карточка", 2 /* CLASS */),
                  _createElementVNode("button", {
                    class: _normalizeClass({active:$setup.detailTab==='activity'}),
                    onClick: _cache[27] || (_cache[27] = $event => ($setup.detailTab='activity'))
                  }, [
                    _cache[58] || (_cache[58] = _createTextVNode("Активность ", -1 /* CACHED */)),
                    _createElementVNode("span", null, _toDisplayString($setup.activity.length), 1 /* TEXT */)
                  ], 2 /* CLASS */)
                ]),
                ($setup.detailTab==='details')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("section", _hoisted_39, [
                        _createElementVNode("h3", null, _toDisplayString($setup.tr('description')), 1 /* TEXT */),
                        _createVNode($setup["RichTextEditor"], {
                          modelValue: $setup.taskEdit.description,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => (($setup.taskEdit.description) = $event))
                        }, null, 8 /* PROPS */, ["modelValue"]),
                        _createElementVNode("button", {
                          class: "primary save-description",
                          disabled: $setup.saving,
                          onClick: $setup.saveTask
                        }, _toDisplayString($setup.saving ? "…" : $setup.tr('save')), 9 /* TEXT, PROPS */, _hoisted_40)
                      ]),
                      _createElementVNode("section", _hoisted_41, [
                        _createElementVNode("h3", null, _toDisplayString($setup.tr('links')), 1 /* TEXT */),
                        _createVNode($setup["EntityLinks"], {
                          "entity-type": "CrmTask",
                          "entity-id": $setup.selected.id,
                          links: $setup.selected.links,
                          onRefresh: _cache[29] || (_cache[29] = $event => ($setup.loadTask($setup.selected.id)))
                        }, null, 8 /* PROPS */, ["entity-id", "links"])
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock("section", _hoisted_42, [
                      _createElementVNode("h3", null, _toDisplayString($setup.tr('comments')), 1 /* TEXT */),
                      _createVNode($setup["RichTextEditor"], {
                        modelValue: $setup.newTaskComment,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => (($setup.newTaskComment) = $event))
                      }, null, 8 /* PROPS */, ["modelValue"]),
                      _createElementVNode("button", {
                        class: "primary save-description",
                        disabled: !$setup.newTaskComment,
                        onClick: $setup.addTaskComment
                      }, "Добавить комментарий", 8 /* PROPS */, _hoisted_43),
                      _createElementVNode("div", _hoisted_44, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activity, (item) => {
                          return (_openBlock(), _createElementBlock("article", {
                            key: `${item.activityType}-${item.id}`,
                            class: "activity-item"
                          }, [
                            _createElementVNode("div", _hoisted_45, _toDisplayString((item.user?.name || item.actor?.name || 'S').slice(0,1)), 1 /* TEXT */),
                            _createElementVNode("div", null, [
                              _createElementVNode("header", null, [
                                _createElementVNode("strong", null, _toDisplayString(item.user?.name || item.actor?.name || 'Система'), 1 /* TEXT */),
                                _createElementVNode("span", null, _toDisplayString(item.activityType === 'comment' ? 'добавил комментарий' : 'изменил карточку'), 1 /* TEXT */),
                                _createVNode($setup["DualTime"], {
                                  value: item.at
                                }, null, 8 /* PROPS */, ["value"])
                              ]),
                              (item.activityType==='comment')
                                ? (_openBlock(), _createBlock($setup["RichContent"], {
                                    key: 0,
                                    html: item.body
                                  }, null, 8 /* PROPS */, ["html"]))
                                : (_openBlock(), _createElementBlock("code", _hoisted_46, _toDisplayString(item.changeset), 1 /* TEXT */))
                            ])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]))
              ]),
              _createElementVNode("aside", _hoisted_47, [
                _createElementVNode("section", _hoisted_48, [
                  _createElementVNode("h3", null, _toDisplayString($setup.tr('details')), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("span", null, _toDisplayString($setup.tr('stage')), 1 /* TEXT */),
                    _createVNode($setup["InlineSelect"], {
                      modelValue: $setup.taskEdit.stage_id,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => (($setup.taskEdit.stage_id) = $event)),
                      options: $setup.stages,
                      onChange: $setup.saveTask
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("span", null, _toDisplayString($setup.tr('assignee')), 1 /* TEXT */),
                    _createVNode($setup["InlineSelect"], {
                      modelValue: $setup.taskEdit.assignee_id,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => (($setup.taskEdit.assignee_id) = $event)),
                      options: $setup.users,
                      onChange: $setup.saveTask
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("span", null, _toDisplayString($setup.tr('partner')), 1 /* TEXT */),
                    _createVNode($setup["PartnerPicker"], {
                      modelValue: $setup.taskEdit.partner_id,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => (($setup.taskEdit.partner_id) = $event)),
                      selected: $setup.selected.partner,
                      onChange: $setup.saveTask
                    }, null, 8 /* PROPS */, ["modelValue", "selected"])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("span", null, _toDisplayString($setup.tr('priority')), 1 /* TEXT */),
                    _createVNode($setup["InlineSelect"], {
                      modelValue: $setup.taskEdit.priority,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => (($setup.taskEdit.priority) = $event)),
                      options: [{value:'lowest',label:'Самый низкий'},{value:'low',label:'Низкий'},{value:'medium',label:'Средний'},{value:'high',label:'Высокий'},{value:'highest',label:'Критический'}],
                      onChange: $setup.saveTask
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("span", null, _toDisplayString($setup.tr('deadline')), 1 /* TEXT */),
                    _createVNode($setup["DeadlinePicker"], {
                      modelValue: $setup.taskEdit.deadline_at,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => (($setup.taskEdit.deadline_at) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createElementVNode("button", {
                      class: "primary",
                      disabled: $setup.saving,
                      onClick: $setup.saveTask
                    }, _toDisplayString($setup.saving ? 'Сохранение…' : 'Сохранить дедлайн'), 9 /* TEXT, PROPS */, _hoisted_54)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("span", null, _toDisplayString($setup.tr('author')), 1 /* TEXT */),
                    _createElementVNode("strong", null, _toDisplayString($setup.selected.creator.name), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("section", _hoisted_56, [
                  _cache[61] || (_cache[61] = _createElementVNode("h3", null, "Архив", -1 /* CACHED */)),
                  ($setup.selected.archived_at)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_57, [
                        _cache[59] || (_cache[59] = _createTextVNode("Задача архивирована ", -1 /* CACHED */)),
                        _createVNode($setup["DualTime"], {
                          value: $setup.selected.archived_at
                        }, null, 8 /* PROPS */, ["value"])
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[60] || (_cache[60] = _createElementVNode("p", null, "Задача исчезнет с канбана, но останется доступна через фильтр списка.", -1 /* CACHED */)),
                        _createElementVNode("button", {
                          class: "danger",
                          disabled: $setup.saving,
                          onClick: $setup.archiveTask
                        }, "Архивировать задачу", 8 /* PROPS */, _hoisted_58)
                      ], 64 /* STABLE_FRAGMENT */))
                ]),
                _createElementVNode("section", _hoisted_59, [
                  _createElementVNode("div", null, [
                    _cache[62] || (_cache[62] = _createElementVNode("span", null, "Создана", -1 /* CACHED */)),
                    _createVNode($setup["DualTime"], {
                      value: $setup.selected.created_at
                    }, null, 8 /* PROPS */, ["value"])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[63] || (_cache[63] = _createElementVNode("span", null, "Обновлена", -1 /* CACHED */)),
                    _createVNode($setup["DualTime"], {
                      value: $setup.selected.updated_at
                    }, null, 8 /* PROPS */, ["value"])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[64] || (_cache[64] = _createElementVNode("span", null, "Закрыта", -1 /* CACHED */)),
                    _createVNode($setup["DualTime"], {
                      value: $setup.selected.completed_at,
                      empty: "—"
                    }, null, 8 /* PROPS */, ["value"])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}